/* =====================================================================
   VA1 (2026-09-29): WHAT A VISIT DID, ONE ANONYMOUS SUMMARY PER PAGE.
   Tommy: "I want to add some useful analytics to see how users are using
   stuff ... how they've actually moving about and what they're struggling
   with?" — and after a friend played: "is there any way to find out what
   he did/saw currently?" (there was not: the run lives in the reader's
   browser, TK1).

   FIRST PARTY AND ANONYMOUS. No cookie, no id kept between visits, no
   third party: one random id for THIS page load, a summary built from the
   getters the page already publishes (the same ones terminal.js reads for
   survey_state), sent to our own /api/visit with sendBeacon when the page
   is hidden or left, and every couple of minutes while it is open, each
   send overwriting the last. What is NOT sent: anything typed (a
   terminal command is kept only if it is one of the machine's own
   command words, a drawn handle only as "a handle was drawn"), the
   reader's clock or address, a stored identifier.

   IT READS, IT NEVER DRIVES. A second's poll of the page's own state,
   and each change becomes one line of the timeline: [seconds since the
   page began, what, detail]. A getter that throws is skipped; nothing
   here can stop the room.

   OFF for the harness and for Tommy's own browsing: `window.TL_NO_VISIT`
   (the screens bench sets it before the page runs) or localStorage
   `tl-visits-off` = '1'.
   ===================================================================== */
(function () {
  'use strict';
  var off = false;
  try { off = !!window.TL_NO_VISIT || localStorage.getItem('tl-visits-off') === '1'; } catch (e) {}
  if (off || navigator.webdriver) return;

  var T0 = (window.performance && performance.timeOrigin) || Date.now();
  var now = function () { return Math.round((Date.now() - T0) / 1000); };
  var ID = (function () {
    var a = new Uint8Array(9);
    try { crypto.getRandomValues(a); } catch (e) { for (var i = 0; i < 9; i++) a[i] = Math.random() * 256 | 0; }
    return btoa(String.fromCharCode.apply(null, a)).replace(/\+/g, '-').replace(/\//g, '_');
  })();
  var TL_MAX = 400, ERR_MAX = 8;

  function apiBase() {
    var m = /[?&]api=([^&]*)/.exec(location.search);
    return ((m ? decodeURIComponent(m[1]) : '') || location.origin).replace(/\/+$/, '');
  }
  function refHost() {
    try { var u = new URL(document.referrer); return u.host === location.host ? '' : u.host; } catch (e) { return ''; }
  }
  /* a reader who has been before: progress.js stamps the first visit once
     (tl-survey-first), and a stamp older than this page is a return. Only
     how many whole days ago is kept. */
  var returning = null;
  try {
    var first = parseInt(localStorage.getItem('tl-survey-first') || '', 10);
    if (isFinite(first) && first > 0 && first < T0 - 5000) returning = Math.floor((T0 - first) / 86400000);
  } catch (e) {}

  var V = {
    v: 1, id: ID, path: location.pathname, ref: refHost(),
    share: window.SURVEY_CARD || null, returning: returning,   /* null, or days since the first visit */
    dev: {
      w: window.innerWidth, h: window.innerHeight, dpr: +(window.devicePixelRatio || 1).toFixed(2),
      touch: (navigator.maxTouchPoints || 0) > 0, cores: navigator.hardwareConcurrency || null,
      mem: navigator.deviceMemory || null, lang: navigator.language || '', gpu: null
    },
    ready: null, dur: 0, vis: 0, had: null, finds: [], tl: [], n: { down: 0, wheel: 0, key: 0, resize: 0 },
    err: [], end: null, boot: null
  };
  /* LD1 (2026-10-02): was the tab in front when the page began? A tab
     opened behind keeps its timers throttled and its boot slow for a
     reason that is not the machine. */
  var hiddenAtStart = document.visibilityState !== 'visible';

  function line(what, detail) {
    if (V.tl.length >= TL_MAX) return;
    V.tl.push(detail === undefined ? [now(), what] : [now(), what, detail]);
  }
  function safe(fn) { try { return fn(); } catch (e) { return undefined; } }

  /* ---- the reader's hands, counted and never recorded ---------------- */
  addEventListener('pointerdown', function () { V.n.down++; }, true);
  addEventListener('wheel', function () { V.n.wheel++; }, { capture: true, passive: true });
  addEventListener('keydown', function (e) {
    V.n.key++;
    /* a command typed at the machine: its first word, if it is one of the
       machine's own words, and '?' when it is not (that is the struggle) */
    if (e.key !== 'Enter' || !window.RoomTerm || !RoomTerm.focused || !RoomTerm.focused()) return;
    var el = document.activeElement, word = el && el.value ? String(el.value).trim().split(/\s+/)[0].toLowerCase() : '';
    if (!word) return;
    var known = safe(function () { return RoomTerm.names(); }) || [];
    line('cmd', known.indexOf(word) >= 0 ? word : '?');
  }, true);
  var rz = 0;
  addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { V.n.resize++; }, 400); });
  function err(m) { if (V.err.length < ERR_MAX) V.err.push([now(), String(m || '').slice(0, 200)]); }
  addEventListener('error', function (e) { err(e.message || (e.target && e.target.src ? 'load ' + e.target.src : 'error')); }, true);
  addEventListener('unhandledrejection', function (e) { err('rejection ' + ((e.reason && e.reason.message) || e.reason)); });

  /* ---- visible time --------------------------------------------------- */
  var visFrom = document.visibilityState === 'visible' ? Date.now() : 0, visMs = 0;
  function visNow() { return Math.round((visMs + (visFrom ? Date.now() - visFrom : 0)) / 1000); }

  /* ---- the page's state, once a second, as changes -------------------- */
  var last = {};
  function note(key, val, show) {
    if (val === undefined || last[key] === val) return;
    var first = !(key in last);
    last[key] = val;
    if (first && show === 'quiet') return;
    line(key, val);
  }
  /* LD1 (2026-10-02): how the boot went, so a slow first visit can be
     read from the beacon instead of guessed (the M3 visit: readyMs 6.2 s,
     and nothing to say whether it was compiling, the network or a hidden
     tab). Every ms is from the engine's own boot() unless named nav:
     start = boot() in page time, f1 frame 1, worker the field worker's
     answer, open the map opening, ready READY; par = the driver compiles
     in parallel (KHR_parallel_shader_compile); slow = the three slowest
     programs, [name, ms]; nav = responseEnd and domContentLoaded in page
     time; hid = the tab began hidden. */
  function bootTimes() {
    var R = window.Room, b = R.boot || {}, r1 = function (x) { return typeof x === 'number' && isFinite(x) ? Math.round(x) : null; };
    var pm = R.progMs || {}, slow = Object.keys(pm).map(function (k) { return [k, r1(pm[k])]; })
      .sort(function (a, c) { return c[1] - a[1]; }).slice(0, 3);
    var nav = safe(function () { return performance.getEntriesByType('navigation')[0]; }) || {};
    return { start: r1(b.enter), f1: r1(b.frame1), worker: r1(b.worker), open: r1(b.open), ready: r1(b.ready),
             par: R.parallelCompile == null ? null : !!R.parallelCompile, slow: slow,
             nav: { re: r1(nav.responseEnd), dcl: r1(nav.domContentLoadedEventEnd) }, hid: hiddenAtStart };
  }
  function zoomBand(w) { return w < 10 ? 'close' : w < 40 ? 'mid' : 'far'; }
  function sample() {
    var R = window.Room;
    if (!R) return;
    if (V.ready === null && R.readyMs) {
      V.ready = Math.round(R.readyMs);
      line('ready', V.ready);
      V.dev.gpu = safe(function () { return String(R.state().renderer || '').slice(0, 120); }) || null;
      if (R.progress && V.had === null) V.had = safe(function () { return R.progress.struck(); }) || [];
      V.boot = safe(bootTimes) || null;
    }
    if (!R.readyMs) return;
    note('view', safe(function () { return R.mode(); }), 'quiet');
    note('fold', safe(function () { return R.folded() > 0.5 ? 'folded' : 'open'; }), 'quiet');
    note('laptop', safe(function () { return R.lapUp() ? 'up' : 'down'; }), 'quiet');
    note('term', safe(function () { return window.RoomTerm && RoomTerm.up() ? 'on' : 'off'; }), 'quiet');
    note('oldsite', safe(function () { return window.RoomTerm && RoomTerm.browsing() ? 'on' : 'off'; }), 'quiet');
    note('handle', safe(function () { return R.subject && R.subject() ? 'drawn' : 'his'; }), 'quiet');
    note('card', safe(function () { var c = R.cardPresented(); return c ? String(c.date || c.name || 'card') : 'none'; }), 'quiet');
    note('curtains', safe(function () { return window.RoomPlace && RoomPlace.curtains ? RoomPlace.curtains() : undefined; }), 'quiet');
    note('book', safe(function () {
      var b = window.RoomBooks && RoomBooks.state();
      if (!b || !b.open) return 'shut';
      return b.open === 'key' ? 'fieldbook' : (b.post ? 'essay ' + b.post : 'journal p' + b.page);
    }), 'quiet');
    note('boat', safe(function () { return R.voyage && R.voyage.state ? R.voyage.state().state : undefined; }), 'quiet');
    note('chart', safe(function () { var c = R.voyage.charted(); return c.n + '/' + c.of; }), 'quiet');
    note('zoom', safe(function () { return zoomBand(R.windowWeeks()); }), 'quiet');
    note('year', safe(function () { var c = R.centre(), d = R.dayAtMap(c.x, c.y); return d && d.date ? d.date.slice(0, 4) : undefined; }), 'quiet');
    note('tilt', safe(function () { return Math.abs(R.tiltDeg()) > 4 || Math.abs(R.yawDeg()) > 4 ? 'tilted' : 'flat'; }), 'quiet');
  }
  var poll = setInterval(sample, 1000);

  /* the finds, as they land, with the active clock and the door they came
     through (progress.js keeps the door in its journal) */
  function hookProgress() {
    var G = window.Room && Room.progress;
    if (!G || !G.onChange) return false;
    var seen = {};
    (safe(function () { return G.struck(); }) || []).forEach(function (n) { seen[n] = 1; });
    G.onChange(function () {
      (safe(function () { return G.struck(); }) || []).forEach(function (n) {
        if (seen[n]) return;
        seen[n] = 1;
        var j = safe(function () { return G.journal(); }), door = j && j.marks && j.marks[n] ? j.marks[n].door : null;
        V.finds.push([n, now(), Math.round((safe(function () { return G.active(); }) || 0) / 1000), door || null]);
        line('found', n);
      });
    });
    return true;
  }
  (function tryHook(k) { if (!hookProgress() && k < 60) setTimeout(function () { tryHook(k + 1); }, 500); })(0);

  /* ---- the send: the whole summary, overwriting the last -------------- */
  function snapshot() {
    V.dur = now(); V.vis = visNow();
    V.end = {};
    for (var k in last) V.end[k] = last[k];
    return JSON.stringify(V);
  }
  var sentAt = 0;
  function send() {
    if (V.ready === null && now() < 5) return;
    var body = snapshot(), url = apiBase() + '/api/visit';
    sentAt = Date.now();
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) return;
    } catch (e) {}
    try { fetch(url, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }); } catch (e) {}
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') { if (!visFrom) visFrom = Date.now(); line('back'); }
    else { if (visFrom) { visMs += Date.now() - visFrom; visFrom = 0; } line('away'); sample(); send(); }
  });
  addEventListener('pagehide', function () { sample(); send(); clearInterval(poll); });
  /* the first send once the reader has had a look, then every two minutes
     the page is in front — so a tab that crashes still leaves its visit */
  setTimeout(send, 20000);
  setInterval(function () { if (document.visibilityState === 'visible' && Date.now() - sentAt > 110000) send(); }, 120000);

  window.RoomVisit = { id: function () { return ID; }, summary: function () { return JSON.parse(snapshot()); }, send: send };
})();
